<template>
  <div class="moz-title">
    <span class="title">
      <slot name="title" />
    </span>
    <span class="subtitle">
      <slot name="subtitle" />
    </span>
  </div>
</template>

<script>
export default {
  name: 'MozTitle',
};
</script>

<style lang="scss" scoped>
  .moz-title {
    text-align: center;
    margin-bottom: 40px;
  }

  .title,
  .subtitle {
    display: block;
  }

  .title {
    font-size: 18px;
    font-weight: bold;
    line-height: 1.56;
    color: #484848;
    margin: 48px 0 32px;
  }

  .subtitle {
    > span {
      display: block;
      font-size: 16px;
      line-height: 1.75;
      color: #373f47;
    }
  }
</style>
